export default __webpack_public_path__ + "static/media/warning--skewed-t-roads-right--g2.733f022e.png";